import { memo, useState } from 'react'
import AudioCirclePlayer from 'components/AudioCirclePlayer'
import { ITtsSpeaker } from 'types/text-to-speech'
import AdvancedTooltip from 'common-components/AdvancedTooltip'
import SpeakerItemTextContent from './TextContent'
import * as Styled from './styled'
import { translate } from 'utils/translations'
import { T } from 'consts/translationKeys'
interface IProps {
  item: ITtsSpeaker | null
  size?: number
  type?: 'speaker' | 'language'
  isActive?: boolean
  isHeader?: boolean
  onClick?: () => void
  className?: string
}

const TtsSpeakerItem: React.FC<IProps> = props => {
  const {
    item,
    isActive = false,
    isHeader = false,
    onClick = () => {},
    className
  } = props

  const { displayName, gender, sample, hasEmotion, isPremium } = item || {}

  const [wrapperRef, setWrapperRef] = useState<HTMLDivElement | null>(null)

  return (
    <Styled.TtsSpeakerItemWrapper
      ref={setWrapperRef}
      className={className}
      onClick={onClick}
      $isActive={isActive}
      $isHeader={isHeader}
    >
      <SpeakerItemTextContent
        displayName={displayName}
        gender={gender}
        isActive={isActive}
        isHeader={isHeader}
        hasEmotion={hasEmotion}
        isPremium={isPremium}
      />
      {!isHeader && sample && (
        <AudioCirclePlayer
          src={sample}
          playIconSize={16}
          resumeIconSize={16}
          progressStrokeColor="#518DFF"
          initialStrokeColor="transparent"
        />
      )}
      {isHeader && (
        <AdvancedTooltip
          tooltipText={translate(T.VOICE)}
          tooltipPosition="top"
          btnRef={{ current: wrapperRef }}
        />
      )}
    </Styled.TtsSpeakerItemWrapper>
  )
}

export default memo(TtsSpeakerItem)
